/** USER ROLES */
export const ADMIN = 'ADMIN';

export const USER_ROLES = {
  ADMIN,
};
